import axios from 'axios';
import Promise from 'bluebird';
import Rest from 'services/data/rest';
import { alerts } from 'modules/alerts/actions';

export default class File extends Rest {
  static path = 'file';
  static defaultQuery = {};

  static list(id, options) {
    return Promise.resolve(axios.get(`/api/file/${id}/list`, options))
      .tap(this.logRequest)
      .get('data')
      .catch(alerts.catchError);
  }

  static addToFolder(id, body) {
    return Promise.resolve(axios.post(`/api/file/${id}/add`, body))
      .tap(this.logRequest)
      .get('data')
      .catch(alerts.catchError);
  }
}
